import createStore from "zustand";

const useUser = createStore((set) => ({
  user: null,
  setUser: (user) => set({ user }),
}));

export { useUser };
